import React from 'react';
import { motion } from 'framer-motion';
import { FileSpreadsheet } from 'lucide-react';
export function Solution() {
  return <section className="py-20 bg-stone-50 border-t border-gray-100" data-id="element-157">
      <div className="container mx-auto px-4 md:px-6" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto text-center" data-id="element-159">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-full shadow-sm border border-gray-100 mb-6" data-id="element-160">
            <FileSpreadsheet className="w-5 h-5 text-teal-600" data-id="element-161" />
            <span className="text-sm font-medium text-gray-600" data-id="element-162">
              Google Sheets Template
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-163">
            Un sistema simple para ordenar tus finanzas personales
          </h2>
          <div className="space-y-4 text-lg text-gray-600" data-id="element-164">
            <p data-id="element-165">
              Esta plantilla no es para contadores ni expertos en Excel. Está
              diseñada para
              <span className="font-semibold text-gray-800" data-id="element-166">
                {' '}
                personas reales
              </span>{' '}
              con gastos y deudas reales.
            </p>
            <p data-id="element-167">
              Olvidate de fórmulas complejas o software difícil de entender. Acá
              solo ingresás tus datos y automáticamente obtenés la claridad que
              necesitás para tomar el control.
            </p>
            <p data-id="element-168">
              Es el puente entre el caos financiero y la tranquilidad mental de
              saber exactamente dónde estás parado.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}